export default __webpack_public_path__ + "static/media/RtTech Software.2ef12bfd.png";